import(/* webpackMode: "eager" */ "/tutearn/app/global-error.tsx")